// Componenti e utilità condivise dell'interfaccia (design system TicketDesk)

export const STATUS = {
  aperto:         { label: 'Aperto',         dot: '#f59e0b', bg: '#fffaeb', text: '#b54708', border: '#fedf89' },
  in_lavorazione: { label: 'In lavorazione', dot: '#f04438', bg: '#fef3f2', text: '#b42318', border: '#fecdca' },
  risolto:        { label: 'Risolto',        dot: '#98a2b3', bg: '#f2f4f7', text: '#475467', border: '#e4e7ec' },
}
export const STATUS_ORDER = ['aperto', 'in_lavorazione', 'risolto']
export const normStatus = (s) => (s === 'chiuso' ? 'risolto' : (STATUS[s] ? s : 'aperto'))

const PATHS = {
  dashboard: <><rect width="7" height="9" x="3" y="3" rx="1.5" /><rect width="7" height="5" x="14" y="3" rx="1.5" /><rect width="7" height="9" x="14" y="12" rx="1.5" /><rect width="7" height="5" x="3" y="16" rx="1.5" /></>,
  inbox: <><polyline points="22 12 16 12 14 15 10 15 8 12 2 12" /><path d="M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z" /></>,
  user: <><path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" /></>,
  userX: <><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><line x1="17" x2="22" y1="8" y2="13" /><line x1="22" x2="17" y1="8" y2="13" /></>,
  userPlus: <><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><line x1="19" x2="19" y1="8" y2="14" /><line x1="22" x2="16" y1="11" y2="11" /></>,
  circleDot: <><circle cx="12" cy="12" r="9" /><circle cx="12" cy="12" r="2.5" fill="currentColor" stroke="none" /></>,
  clock: <><circle cx="12" cy="12" r="9" /><polyline points="12 7 12 12 15.5 14" /></>,
  checkCircle: <><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" /><polyline points="22 4 12 14.01 9 11.01" /></>,
  layers: <><polygon points="12 2 2 7 12 12 22 7 12 2" /><polyline points="2 17 12 22 22 17" /><polyline points="2 12 12 17 22 12" /></>,
  plus: <><line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" /></>,
  settings: <><circle cx="12" cy="12" r="3" /><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" /></>,
  search: <><circle cx="11" cy="11" r="7" /><line x1="21" y1="21" x2="16.65" y2="16.65" /></>,
  logout: <><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" /><polyline points="16 17 21 12 16 7" /><line x1="21" y1="12" x2="9" y2="12" /></>,
  arrowLeft: <><line x1="19" y1="12" x2="5" y2="12" /><polyline points="12 19 5 12 12 5" /></>,
  arrowRight: <><line x1="5" y1="12" x2="19" y2="12" /><polyline points="12 5 19 12 12 19" /></>,
  paperclip: <path d="m21.44 11.05-9.19 9.19a6 6 0 0 1-8.49-8.49l8.57-8.57A4 4 0 1 1 18 8.84l-8.59 8.57a2 2 0 0 1-2.83-2.83l8.49-8.48" />,
  send: <><line x1="22" y1="2" x2="11" y2="13" /><polygon points="22 2 15 22 11 13 2 9 22 2" /></>,
  lock: <><rect x="3" y="11" width="18" height="11" rx="2" ry="2" /><path d="M7 11V7a5 5 0 0 1 10 0v4" /></>,
  mail: <><rect width="20" height="16" x="2" y="4" rx="2" /><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" /></>,
  x: <><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></>,
  download: <><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><polyline points="7 10 12 15 17 10" /><line x1="12" y1="15" x2="12" y2="3" /></>,
  upload: <><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><polyline points="17 8 12 3 7 8" /><line x1="12" y1="3" x2="12" y2="15" /></>,
  file: <><path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z" /><polyline points="14 2 14 8 20 8" /></>,
  image: <><rect width="18" height="18" x="3" y="3" rx="2" ry="2" /><circle cx="9" cy="9" r="2" /><path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21" /></>,
  message: <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />,
  calendar: <><rect width="18" height="18" x="3" y="4" rx="2" ry="2" /><line x1="16" x2="16" y1="2" y2="6" /><line x1="8" x2="8" y1="2" y2="6" /><line x1="3" x2="21" y1="10" y2="10" /></>,
  alert: <><circle cx="12" cy="12" r="10" /><line x1="12" x2="12" y1="8" y2="12" /><line x1="12" x2="12.01" y1="16" y2="16" /></>,
  check: <polyline points="20 6 9 17 4 12" />,
  barChart: <><line x1="12" x2="12" y1="20" y2="10" /><line x1="18" x2="18" y1="20" y2="4" /><line x1="6" x2="6" y1="20" y2="16" /></>,
  at: <><circle cx="12" cy="12" r="4" /><path d="M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-4 8" /></>,
  save: <><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" /><polyline points="17 21 17 13 7 13 7 21" /><polyline points="7 3 7 8 15 8" /></>,
  sort: <><path d="m3 16 4 4 4-4" /><path d="M7 20V4" /><path d="m21 8-4-4-4 4" /><path d="M17 4v16" /></>,
  sparkles: <><path d="m12 3-1.9 5.8a2 2 0 0 1-1.3 1.3L3 12l5.8 1.9a2 2 0 0 1 1.3 1.3L12 21l1.9-5.8a2 2 0 0 1 1.3-1.3L21 12l-5.8-1.9a2 2 0 0 1-1.3-1.3Z" /></>,
  shield: <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />,
  zap: <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />,
}

export function Icon({ name, size = 16, strokeWidth = 2, className, style }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"
      className={className} style={{ flexShrink: 0, ...style }} aria-hidden="true">
      {PATHS[name]}
    </svg>
  )
}

export function initialsOf(s) {
  if (!s) return '?'
  const base = s.includes('@') ? s.split('@')[0] : s
  const parts = base.replace(/[._\-+]+/g, ' ').trim().split(/\s+/)
  return ((parts[0]?.[0] || '') + (parts[1]?.[0] || '')).toUpperCase() || '?'
}

const PALETTE = ['#4f46e5', '#0e9384', '#2e90fa', '#dd2590', '#7a5af8', '#f79009', '#039855', '#e04f16']
export function colorOf(s = '') {
  let h = 0
  for (const c of s) h = (h * 31 + c.charCodeAt(0)) >>> 0
  return PALETTE[h % PALETTE.length]
}

export function Avatar({ name, size = 28, title }) {
  return (
    <span className="avatar" title={title || name}
      style={{ width: size, height: size, fontSize: Math.max(9, Math.round(size * 0.38)), background: colorOf(name || '') }}>
      {initialsOf(name)}
    </span>
  )
}

export function StatusPill({ status, size }) {
  const s = STATUS[normStatus(status)]
  return (
    <span className={`pill${size === 'sm' ? ' pill-sm' : ''}`} style={{ background: s.bg, color: s.text, borderColor: s.border }}>
      <span className="pill-dot" style={{ background: s.dot }} />
      {s.label}
    </span>
  )
}

export function Spinner({ size = 16 }) {
  return <span className="spinner" style={{ width: size, height: size }} />
}

export function EmptyState({ icon = 'inbox', title, text, action }) {
  return (
    <div className="empty">
      <div className="empty-icon"><Icon name={icon} size={22} /></div>
      <div className="empty-title">{title}</div>
      {text && <div className="empty-text">{text}</div>}
      {action}
    </div>
  )
}

export function timeAgo(d) {
  if (!d) return ''
  const date = new Date(d)
  const diff = Date.now() - date
  if (diff < 60000) return 'adesso'
  if (diff < 3600000) return `${Math.floor(diff / 60000)} min fa`
  if (diff < 86400000) return `${Math.floor(diff / 3600000)} h fa`
  if (diff < 7 * 86400000) {
    const g = Math.floor(diff / 86400000)
    return g === 1 ? 'ieri' : `${g} giorni fa`
  }
  const sameYear = date.getFullYear() === new Date().getFullYear()
  return date.toLocaleDateString('it-IT', { day: '2-digit', month: 'short', ...(sameYear ? {} : { year: 'numeric' }) })
}

export const fmtDateTime = (d) => d
  ? new Date(d).toLocaleString('it-IT', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' })
  : '—'

export function formatSize(bytes) {
  if (!bytes) return ''
  if (bytes < 1024) return `${bytes} B`
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`
}

export function FileIcon({ type, size = 16 }) {
  return <Icon name={(type || '').startsWith('image/') ? 'image' : 'file'} size={size} />
}

// Nome leggibile del richiedente a partire dall'email
export const requesterName = (email) => (email ? email.split('@')[0] : 'Cliente')

// Messaggio del cliente: scritto dal worker (risposta via email, 📧) o dall'area clienti (💬).
// Restituisce mittente, canale e testo senza prefisso; null se il messaggio e' di un operatore.
const CUSTOMER_PREFIXES = [
  { re: /^📧 Risposta via email da ([^\n]+?):\n\n?/, via: 'email' },
  { re: /^💬 Messaggio dall'area clienti da ([^\n]+?):\n\n?/, via: 'portal' },
]
export function parseCustomerMessage(c) {
  if (!c || c.is_internal != null) return null
  const text = c.content || ''
  for (const p of CUSTOMER_PREFIXES) {
    const m = p.re.exec(text)
    if (m) return { sender: m[1], via: p.via, text: text.slice(m[0].length) }
  }
  return null
}

// Pulizia del testo delle email: spazi non separabili, righe di soli spazi, righe vuote ripetute
export function normalizeText(t) {
  return (t || '').replace(/\r\n?/g, '\n').replace(/ /g, ' ')
    .split('\n').map(l => l.replace(/\s+$/, '')).join('\n')
    .replace(/\n{3,}/g, '\n\n')
    .trim()
}

// Inizio della parte citata/inoltrata (righe intere, mai una riga qualsiasi che inizia con "Il")
const QUOTE_MARKERS = [
  { re: /^[>\s]*##- Scrivi la tua risposta sopra questa riga -##/m, kind: 'quote' },
  { re: /^[>\s]*-{2,}\s*(?:messaggio inoltrato|forwarded message|inizio messaggio inoltrato)\b.*$/im, kind: 'forward' },
  { re: /^[>\s]*-{2,}\s*(?:original message|messaggio originale)\s*-{2,}/im, kind: 'quote' },
  { re: /^[>\s*]*(?:da|from)[ \t]*:.*\n[>\s*]*(?:inviato|sent|data|date)[ \t]*:.*\n(?:.*\n){0,4}?[>\s*]*(?:oggetto|subject)[ \t]*:.*$/im, kind: 'header' },
  { re: /^[>\s]*(?:il|on)\s.{4,200}(?:ha scritto|wrote)\s*:\s*$/im, kind: 'quote' },
  { re: /^>.*\n>/m, kind: 'quote' },
]

// Divide un messaggio in testo nuovo (main) e parte citata/inoltrata (quoted, da mostrare chiusa)
export function splitQuoted(text) {
  const t = normalizeText(text)
  let best = null
  for (const m of QUOTE_MARKERS) {
    const i = t.search(m.re)
    if (i > 0 && (!best || i < best.i)) best = { i, kind: m.kind }
  }
  if (!best) return { main: t, quoted: '', label: '' }
  const main = t.slice(0, best.i).trim()
  const quoted = t.slice(best.i).trim()
  // Solo materiale inoltrato senza testo sopra: si mostra tutto, altrimenti non si vedrebbe niente
  if (!main) return { main: t, quoted: '', label: '' }

  const subject = (quoted.match(/^[>\s*]*(?:oggetto|subject)[ \t]*:[ \t]*\*?[ \t]*(\S.*)$/im)?.[1] || '').trim()
  const isFwd = best.kind === 'forward' || (best.kind === 'header' && /^(?:fwd?|i|inoltro|tr)\s*:/i.test(subject))
  const label = (isFwd ? 'Messaggio inoltrato' : best.kind === 'header' ? 'Messaggio precedente' : 'Testo citato')
    + (subject ? ` · ${subject.length > 70 ? subject.slice(0, 70) + '…' : subject}` : '')
  return { main, quoted, label }
}
